<template>
  <div class="homework-manage">
    <div class="header">
      <el-input
        v-model="keyword"
        placeholder="搜索作业标题"
        style="width: 250px; margin-right: 10px"
        @keyup.enter.native="search"
      >
        <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
      </el-input>
      <!-- <el-button type="primary" @click="showAddDialog">上传作业</el-button> -->
    </div>

    <el-table :data="homeworkList" style="width: 100%; margin-top: 20px">
      <el-table-column prop="id" label="ID" width="80" />
      <el-table-column label="作业图片" width="120">
        <template slot-scope="scope">
          <el-image 
            v-if="scope.row.homeworkImage" 
            :src="scope.row.homeworkImage" 
            style="width: 80px; height: 60px" 
            fit="cover"
            :preview-src-list="[scope.row.homeworkImage]"
          />
          <span v-else style="color: #999">暂无图片</span>
        </template>
      </el-table-column>
      <el-table-column prop="homeworkTitle" label="作业题目" />
      <el-table-column label="操作" width="180" fixed="right">
        <template slot-scope="scope">
          <el-button size="small" @click="showEditDialog(scope.row)">编辑</el-button>
          <el-button size="small" type="danger" @click="handleDelete(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      :current-page.sync="currentPage"
      :page-size.sync="pageSize"
      :total="total"
      layout="total, prev, pager, next"
      @current-change="loadHomeworkList"
      style="margin-top: 20px; text-align: center"
    />

    <el-dialog :visible.sync="dialogVisible" :title="dialogTitle" width="600px" :close-on-click-modal="false">
      <el-form :model="formData" label-width="100px" :rules="rules" ref="homeworkForm">
        <el-form-item label="作业题目" prop="homeworkTitle">
          <el-input v-model="formData.homeworkTitle" placeholder="请输入作业题目" />
        </el-form-item>
        
        <el-form-item label="作业图片" prop="homeworkImage">
          <el-upload
            class="image-uploader"
            :action="uploadUrl"
            :on-success="handleUploadSuccess"
            :before-upload="beforeUpload"
            :show-file-list="false"
            accept="image/*"
          >
            <img v-if="formData.homeworkImage" :src="formData.homeworkImage" class="image-preview">
            <i v-else class="el-icon-plus image-uploader-icon"></i>
          </el-upload>
          <div style="color: #909399; font-size: 12px; margin-top: 5px">
            支持jpg、png格式，无大小限制
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit" :loading="submitting">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import homeworkApi from '@/api/homework'

export default {
  name: 'HomeworkManage',
  data() {
    return {
      keyword: '',
      homeworkList: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      dialogVisible: false,
      dialogTitle: '',
      isEdit: false,
      submitting: false,
      uploadUrl: `${process.env.VUE_APP_API_BASE_URL}/api/homework/upload`,
      formData: {
        id: null,
        homeworkTitle: '',
        homeworkImage: ''
      },
      rules: {
        homeworkTitle: [
          { required: true, message: '请输入作业题目', trigger: 'blur' }
        ],
        homeworkImage: [
          { required: true, message: '请上传作业图片', trigger: 'change' }
        ]
      }
    }
  },
  mounted() {
    this.loadHomeworkList()
  },
  methods: {
    async loadHomeworkList() {
      try {
        const res = await homeworkApi.getHomeworkList(this.currentPage, this.pageSize, this.keyword, null)
        this.homeworkList = res.data.data
        this.total = res.data.total
      } catch (error) {
        this.$message.error('加载作业列表失败')
      }
    },
    search() {
      this.currentPage = 1
      this.loadHomeworkList()
    },
    showAddDialog() {
      this.dialogTitle = '上传作业'
      this.isEdit = false
      this.formData = {
        id: null,
        homeworkTitle: '',
        homeworkImage: ''
      }
      this.dialogVisible = true
      this.$nextTick(() => {
        if (this.$refs.homeworkForm) {
          this.$refs.homeworkForm.clearValidate()
        }
      })
    },
    showEditDialog(row) {
      this.dialogTitle = '编辑作业'
      this.isEdit = true
      this.formData = { ...row }
      this.dialogVisible = true
    },
    beforeUpload(file) {
      const isImage = file.type.startsWith('image/')

      if (!isImage) {
        this.$message.error('只能上传图片文件!')
        return false
      }
      return true
    },
    handleUploadSuccess(response) {
      if (response.code === 200) {
        this.formData.homeworkImage = response.data
        this.$message.success('上传成功')
      } else {
        this.$message.error('上传失败')
      }
    },
    async handleSubmit() {
      this.$refs.homeworkForm.validate(async (valid) => {
        if (valid) {
          this.submitting = true
          try {
            if (this.isEdit) {
              await homeworkApi.updateHomework(this.formData)
              this.$message.success('更新成功')
            } else {
              await homeworkApi.addHomework(this.formData)
              this.$message.success('添加成功')
            }
            this.dialogVisible = false
            this.loadHomeworkList()
          } catch (error) {
            this.$message.error(this.isEdit ? '更新失败' : '添加失败')
          } finally {
            this.submitting = false
          }
        }
      })
    },
    handleDelete(id) {
      this.$confirm('确定要删除这个作业吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          await homeworkApi.deleteHomework(id)
          this.$message.success('删除成功')
          this.loadHomeworkList()
        } catch (error) {
          this.$message.error('删除失败')
        }
      })
    }
  }
}
</script>

<style scoped>
.homework-manage {
  padding: 20px;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.image-uploader {
  display: inline-block;
}

.image-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 100px;
  line-height: 100px;
  text-align: center;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
}

.image-uploader-icon:hover {
  border-color: #409EFF;
}

.image-preview {
  width: 178px;
  height: 100px;
  display: block;
  border-radius: 6px;
  object-fit: cover;
  cursor: pointer;
}
</style>
